import { TFunction } from "next-i18next";
import { UTSLocaleToLanguage } from "@smile2impress/attraction-constants";

import { PageContentProps } from "content/content.types";
import { mergeContent } from "utils/mergeContent";
import { UrlsConfig } from "configs/urlsConfig";
import contacts from "configs/contacts";
import { ContactTypes, SocialTypes } from "constants/enum";
import { getWALink } from "utils/getWALink";

import defaultContent from "./common";

const pageContent = (t: TFunction, { locale }: PageContentProps) => {
    const content = defaultContent(t, { locale });

    return mergeContent(content, {
        contacts: {
            wa: {
                text: t("navigationMenuRelaunch:navigationWhatsApp"),
                link: contacts.whatsapp[locale].link,
                newPatientsLink: (contacts.whatsapp[locale] as any)
                    .newPatientsLink,
                message: t("global:whatsappMessage"),
            },
        },
        footer: {
            company: {
                links: [
                    ...content.footer.company.links,
                    {
                        id: "studentbeans",
                        name: t("navigationMenuRelaunch:studentBeans"),
                        link: UrlsConfig.STUDENT_BEANS,
                    },
                ],
            },
            product: {
                title: t("global:productFooterText"),
                links: [
                    {
                        id: "aligners",
                        name: t("global:alignersPageTitle"),
                        link: UrlsConfig.ALIGNERS,
                    },
                    {
                        id: "teens",
                        name: t("global:teensPageTitle"),
                        link: UrlsConfig.TEENS,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBDiastema"),
                        link: UrlsConfig.DIASTEMA,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBCrookedTeeth"),
                        link: UrlsConfig.CROOKED_TEETH,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBCrowding"),
                        link: UrlsConfig.CROWDING,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBOverbite"),
                        link: UrlsConfig.OVERBITE,
                    },
                    {
                        name: t("navigationMenuRelaunch:clusterBCrossbite"),
                        link: UrlsConfig.CROSSBITE,
                    },
                ],
            },
            support: {
                title: t("global:supportFooterText"),
                links: [
                    {
                        id: "faq",
                        name: t("global:faqFooterText"),
                        link: `https://faq.smile2impress.com/${UTSLocaleToLanguage[locale]}`,
                    },
                    {
                        id: ContactTypes.PHONE,
                        name: contacts.phone[locale].public,
                        link:
                            contacts.phone[locale].link &&
                            `tel:${contacts.phone[locale].link}`,
                    },
                    {
                        id: SocialTypes.WA,
                        name: "WhatsApp",
                        link: getWALink(
                            (contacts.whatsapp[locale] as any).newPatientsLink,
                            t("global:whatsappMessage")
                        ),
                    },
                    {
                        id: SocialTypes.TG,
                        name: "Telegram",
                        link: contacts.telegram[locale].link,
                    },
                    {
                        id: ContactTypes.EMAIL,
                        name: t("global:email"),
                        link:
                            contacts.email[locale].link &&
                            `mailto:${contacts.email[locale].link}`,
                    },
                ],
            },
        },
    });
};

export default pageContent;
